export default function WeeklyInsights() {
  return (
    <div className="glass-card p-8 rounded-3xl">
      <h2 className="text-2xl font-bold text-black">
        📊 Weekly Insights
      </h2>
    </div>
  );
}